import React from 'react';

export function MyDataTable({ children }: { children: React.ReactNode }) {
  return React.Children.only(children);
}
